<div class="tb-f-container">
    <div class="settings-block">
        <button ion-button icon-only clear (click)="onCloseClick()">
            <ion-icon color="secondary" name="close-circle" class="settings-btn"></ion-icon>
        </button>
    </div>
    <div class="buttons-block">
        <!-- <div class="btn tshirt">
        </div>
        <div class="btn field">
        </div> -->
        <button ion-button small class="share-btn">field</button>
    </div>
</div>